import { AlertTriangle, Check } from "lucide-react"
import type { ReactNode } from "react"
import type { OrderDetail } from "../../services/use-orders"
import { formatDateTime } from "../../lib/format-date"
import { humanizeMarketplaceId } from "../../lib/marketplace"
import { MarketplaceMark } from "../marketplaces/marketplace-mark"
import { StateChip } from "../../routes/orders.index"
import { orderAttention } from "./order-detail-model"

export function OrderHeader({ data, nav }: { data: OrderDetail; nav: ReactNode }) {
  const attention = orderAttention(data)
  const Icon = attention.kind === "good" ? Check : AlertTriangle
  return (
    <header className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground [overflow-wrap:anywhere] sm:text-[28px]">
            {data.orderId}
          </h1>

          <StateChip kind={attention.kind}>
            <Icon className="mr-1 size-3.5" />

            {attention.label}
          </StateChip>
        </div>

        <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-3 text-xs text-muted-foreground">
          <MarketplaceMark marketplace={data.marketplace} className="mr-1 size-6" />

          <span>{`${humanizeMarketplaceId(data.marketplace)} · ${data.platformLabel}`}</span>

          <span>· Created {formatDateTime(data.createdAt)}</span>
        </div>
      </div>

      <div className="shrink-0">{nav}</div>
    </header>
  )
}
